(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],2:[function(require,module,exports){
const rol_accessibility = {
    setup() {
        window.addEventListener('keydown', rol_accessibility.handleFirstTab);
    },

    // Watch for user tabbing and enable focus styles if tab key pressed
    handleFirstTab(e) {
        if (e.keyCode === 9) {
            // the "I am a keyboard user" key
            document.body.classList.add('user-tabbing');
            window.removeEventListener('keydown', rol_accessibility.handleFirstTab);
        }
    },
};

module.exports = rol_accessibility;

},{}],3:[function(require,module,exports){
const debounce = function debounce(func, wait, immediate) {
    let timeout;
    return () => {
        const context = this,
            args = [func, wait, immediate];
        const later = () => {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

module.exports = debounce;

},{}],4:[function(require,module,exports){
const rol_form = {
    profile_image_max_size_kb: 1024,

    setup() {
        rol_form.addCustomCheckboxes();
        rol_form.addCustomRadios();
        rol_form.handleSingleCheckboxes();
        rol_form.profilePicUploaderEvents();

        rol_form.customButtonEvents({
            customButtonId: 'profile-pic__upload',
            originalElementId: 'id_photo',
            doSubmit: false,
        });

        rol_form.customButtonEvents({
            customButtonId: 'profile-pic__clear',
            originalElementId: 'photo-clear_id',
            doSubmit: true,
        });
    },

    addCustomCheckboxes() {
        const checkboxes = document.querySelectorAll('.control-group input[type="checkbox"]');

        rol_form.addElementsAfter({
            existingEls: checkboxes,
            newClassName: 'custom-checkbox',
        });
    },

    addCustomRadios() {
        const radios = document.querySelectorAll('.control-group input[type="radio"]');

        rol_form.addElementsAfter({
            existingEls: radios,
            newClassName: 'custom-radio',
        });
    },

    addElementsAfter({ existingEls, newClassName }) {
        // For an array of existing elements, add custom els immediately after
        // with specified class
        for (let i = 0; i < existingEls.length; i += 1) {
            const this_el = existingEls[i],
                custom_el = document.createElement('div');
            custom_el.classList.add(newClassName);

            // Add the custom checkbox directly after the input element
            if (this_el.nextSibling) {
                this_el.parentNode.insertBefore(
                    custom_el, this_el.nextSibling,
                );
            } else {
                this_el.parentNode.appendChild(custom_el);
            }
        }
    },

    handleSingleCheckboxes() {
        // Where crispy forms has a different layout & input & custom are
        // not children of the label element
        const custom_checkboxes = document.getElementsByClassName('custom-checkbox');

        for (let i = 0; i < custom_checkboxes.length; i += 1) {
            custom_checkboxes[i].addEventListener('click', () => {
                const this_prev_sibling_id = custom_checkboxes[i].previousSibling.id,
                    this_next_sibling = custom_checkboxes[i].nextElementSibling;

                if (this_next_sibling) {
                    const label = this_next_sibling.getAttribute('for');

                    if (label === this_prev_sibling_id) {
                        this_next_sibling.click();
                    }
                }
            });
        }
    },

    customButtonEvents({ customButtonId, originalElementId, doSubmit }) {
        const custom_add_button = document.getElementById(customButtonId),
            target_input = document.getElementById(originalElementId),
            submit_input = document.getElementById('submit-id-submit');

        if (custom_add_button && target_input) {
            // Click on original (non-visible) inputs from custom replacements
            custom_add_button.addEventListener('click', () => {
                if (target_input) {
                    target_input.click();

                    if (doSubmit && submit_input) {
                        submit_input.click();
                    }
                }
            });
        }
    },

    profilePicUploaderEvents() {
        // Add custom handling on profile pic upload
        const uploader = document.getElementById('id_photo');

        if (uploader) {
            uploader.addEventListener('change', rol_form.fileSelectHandler);
        }
    },

    fileSelectHandler(e) {
        // Fetch FileList object
        const files = e.target.files || e.dataTransfer.files;
        // Process one File object
        rol_form.parseFile(files[0]);
    },

    parseFile(file) {
        const imageName = file.name,
            isGood = (/\.(?=gif|jpg|png|jpeg)/gi).test(imageName),
            preview_img = document.getElementById('profile-img-preview'),
            preview_holder = document.getElementById('profile-img__preview-holder'),
            help_message = document.getElementById('profile-pic__help');

        // Check for a correct extension and reasonable size
        if (isGood && file.size < rol_form.profile_image_max_size_kb * 1024) {
            // If ok, upload preview
            preview_img.src = URL.createObjectURL(file);
            preview_holder.classList.add('show');
            help_message.classList.remove('show');
        } else {
            // If not ok, clear input value
            preview_holder.classList.remove('show');
            help_message.classList.add('show');
            document.getElementById('id_photo').value = '';
        }
    },
};

module.exports = rol_form;

},{}],5:[function(require,module,exports){
const rol_form = require('./form.js'),
    rol_search = require('./search.js'),
    rol_sliders = require('./sliders.js'),
    rol_tabs = require('./tabs.js'),
    rol_medium_pages = require('./medium-pages.js'),
    rol_show_hide = require('./show_hide.js'),
    rol_page_reload = require('./page-reload.js'),
    rol_accessibility = require('./accessibility.js');

document.addEventListener('DOMContentLoaded', () => {
    // Setup forms
    rol_form.setup();

    // Setup search (if on search page)
    rol_search.setup();

    // Setup sliders used across site
    rol_sliders.setup();

    // Setup tabs
    rol_tabs.setup();

    // Add 'reading time' on detail pages
    rol_medium_pages.setup();

    // Setup show/hide toggles
    rol_show_hide.setup();

    // For links that reload the page (e.g. bookmark & unbookmark etc)
    // Return to the same scroll position
    rol_page_reload.setup();

    // Add accessibility listeners/functions
    rol_accessibility.setup();
});

},{"./accessibility.js":2,"./form.js":4,"./medium-pages.js":6,"./page-reload.js":7,"./search.js":8,"./show_hide.js":9,"./sliders.js":10,"./tabs.js":11}],6:[function(require,module,exports){
const countable = require('../vendor/countable.min.js');

const rol_medium_pages = {
    words_per_minute: 200,

    setup() {
        // Expecting one detail area only - would need updating to handle multiple
        const detail_area = document.querySelector('.medium__content');

        if (detail_area) {
            countable.count(detail_area, rol_medium_pages.setReadingTime);
        }
    },

    setReadingTime(counter) {
        const reading_time = Math.ceil(counter.words / rol_medium_pages.words_per_minute),
            reading_time_span = document.getElementById('reading-time');

        if (reading_time_span) {
            reading_time_span.innerHTML = `${reading_time} min read`;
        }
    },
};

module.exports = rol_medium_pages;

},{"../vendor/countable.min.js":13}],7:[function(require,module,exports){
const rol_page_reload = {
    setup() {
        const reload_links = document.querySelectorAll('a.page-reload-link');

        for (let i = 0; i < reload_links.length; i += 1) {
            const this_link = reload_links[i],
                this_href = this_link.href;

            this_link.id = `reload_link_${i}`;

            this_link.addEventListener('click', (e) => {
                e.preventDefault();
                rol_page_reload.fadeOutContent();
                if (rol_page_reload.sessionStorageAvailable) {
                    rol_page_reload.saveFocusElement(this_link.id);
                    rol_page_reload.savePageScrollPos();
                }

                window.location.replace(this_href);
            });
        }

        // Check to see if info about focused element & scroll pos is stored
        rol_page_reload.checkStoredInfo();

        // Fade in messages
        rol_page_reload.fadeInMessage();
    },

    fadeInMessage() {
        const messages = document.querySelector('.messages');

        if (messages) {
            messages.classList.add('message-show');
        }
    },

    fadeOutContent() {
        const body = document.querySelector('body');

        if (body) {
            body.classList.add('reload-fade');
        }
    },

    saveFocusElement(focused_link_id) {
        window.sessionStorage.setItem('rol_focused_el', focused_link_id);
    },

    savePageScrollPos() {
        const scroll_pos = window.pageYOffset || document.documentElement.scrollTop;
        window.sessionStorage.setItem('rol_scroll_top', scroll_pos);
    },

    checkStoredInfo() {
        if (rol_page_reload.sessionStorageAvailable) {
            const scroll_top = window.sessionStorage.getItem('rol_scroll_top'),
                focus_el = window.sessionStorage.getItem('rol_focused_el');

            if (scroll_top) {
                document.documentElement.scrollTop = scroll_top;
                window.sessionStorage.setItem('rol_scroll_top', null);
            }

            setTimeout(() => {
                if (focus_el && document.querySelector(`#${focus_el}`)) {
                    document.querySelector(`#${focus_el}`).focus();
                    window.sessionStorage.setItem('rol_focused_el', null);
                }
            }, 0);
        }
    },

    sessionStorageAvailable() {
        try {
            const storage = window.sessionStorage,
                x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        } catch (e) {
            return false;
        }
    },
};

module.exports = rol_page_reload;

},{}],8:[function(require,module,exports){
require('../vendor/promise-polyfill.min.js').polyfill();

const axios = require('../vendor/axios.min.js');

const rol_search = {
    search_results_container: null,
    text_input_value: '',
    api_url_piece: '/api/v1',
    search_param: null,
    current_result_type: 'courses',
    currentResults: {
        courses: null,
        resources: null,
        tags: null,
        authors: null,
    },
    courses_page: 1,
    resources_page: 1,
    timeout_fadeout: null,
    timeout_fadein: null,
    no_results: 'Sorry, there are no results for that search term...',
    error: 'Sorry, we hit an error trying to fetch your results. Please refresh the page to try again.',

    // Tag & author filters
    current_tag_author_arrays: {
        tags: [],
        author: [],
    },
    current_tag_author_params: {
        tags: '',
        author: '',
    },
    filter_holders: {
        tags: null,
        authors: null,
    },
    filter_title_keys: {
        tags: 'title',
        authors: 'full_name',
    },

    setup() {
        const search_text_input = document.getElementById('search__text');
        rol_search.filter_holders.tags = document.getElementById('search__tags-filter');
        rol_search.filter_holders.authors = document.getElementById('search__authors-filter');
        rol_search.search_results_container = document.querySelector('.search__results');

        if (rol_search.search_results_container && search_text_input) {
            // Add event listeners to text input, pagination buttons
            search_text_input.addEventListener('keydown', rol_search.textInputUpdate);
            rol_search.setupPaginationEvents();

            // Change result type & results container on switching tabs
            rol_search.setupTabs();
        }
    },

    setupTabs() {
        const search_tab_btns = document.getElementsByClassName('tabs__button-search');

        for (let i = 0; i < search_tab_btns.length; i += 1) {
            const this_tab_btn = search_tab_btns[i],
                connected_result_type = this_tab_btn.getAttribute('data-search-result-type'),
                connected_tab = this_tab_btn.getAttribute('aria-controls');

            search_tab_btns[i].addEventListener('click', () => {
                rol_search.searchTabClick(connected_result_type, connected_tab);
            });
        }
    },

    searchTabClick(connected_result_type, connected_tab) {
        // On click, as well as standard tab switching, change result type which will be
        // searched for. Check for results in new tab.
        if (connected_result_type !== rol_search.current_result_type) {
            rol_search.current_result_type = connected_result_type;
            rol_search.search_results_container = document.querySelector(`#${connected_tab} .search__results`);

            rol_search.getNewCourseResourceResults(false);
        }
    },

    textInputUpdate() {
        setTimeout(() => {
            const new_value = this.value;

            if (new_value !== '' && new_value !== rol_search.text_input_value) {
                // Update search params
                rol_search.search_param = new_value;
                rol_search.resetTagsAuthorsPage();
                rol_search.getNewCourseResourceResults(true);
                rol_search.getNewTagsAuthorsResults('tags');
                rol_search.getNewTagsAuthorsResults('authors');
            }
        }, 0);
    },

    getNewTagsAuthorsResults(result_type) {
        const search_url = `${rol_search.api_url_piece}/${result_type}`;

        axios.get(`${search_url}?search=${rol_search.search_param}`)
            .then((response) => {
                rol_search.fillNewTagsAuthorsResults(response, result_type);
            })
            .catch(rol_search.showErrorMessage);
    },

    getNewCourseResourceResults(allow_tab_switch_on_empty, manual_result_type) {
        const { tags, author } = rol_search.current_tag_author_params,
            current_result_type = manual_result_type || rol_search.current_result_type,
            search_url = `${rol_search.api_url_piece}/${current_result_type}/`,
            divider = (author !== '' && tags !== '') ? '&' : '',
            multi_params = `${tags}${divider}${author}`,
            page_param = rol_search.current_result_type === 'courses' ? rol_search.courses_page
                : rol_search.resources_page;

        // If tags or authors have been selected, don't also filter by search term as all
        // results connected to that tag/author should be returned
        let search_param_to_use = `&search=${rol_search.search_param}`;
        if (multi_params !== '') {
            search_param_to_use = '';
        }

        axios.get(`${search_url}?page=${page_param}${search_param_to_use}&${multi_params}`)
            .then((response) => {
                if (manual_result_type) {
                    rol_search.nonActiveTabResults(response);
                } else {
                    rol_search.newCourseResourceResults(response, allow_tab_switch_on_empty);
                }
            })
            .catch(rol_search.showErrorMessage);
    },

    showErrorMessage() {
        // reset back to page 1, clear results, show error message
        rol_search.resetTagsAuthorsPage();
        rol_search.search_results_container.innerHTML = '';
        rol_search.showMessage(rol_search.error);
    },

    resetTagsAuthorsPage() {
        rol_search.courses_page = 1;
        rol_search.resources_page = 1;
        rol_search.current_tag_author_arrays.tags = [];
        rol_search.current_tag_author_arrays.author = [];
        rol_search.current_tag_author_params.tags = '';
        rol_search.current_tag_author_params.author = '';
    },

    newCourseResourceResults(response, allow_tab_switch_on_empty) {
        const current_results_by_type = rol_search.currentResults[rol_search.current_result_type];
        // Only change html if results have changed (as request is made on each keystroke)
        if (JSON.stringify(current_results_by_type) !== JSON.stringify(response.data.results)) {
            // Fade out current results
            rol_search.search_results_container.classList.add('fade-out');
            rol_search.clearTimeouts();

            // If no results, check other tab
            // (allow...) prevents this happening repeatedly / on tab click
            if (response.data.results.length === 0 && allow_tab_switch_on_empty) {
                rol_search.getOtherResults();
            }

            // Switch results etc. Only update 'currentResults' when they are on-page
            rol_search.timeout_fadeout = setTimeout(() => {
                rol_search.currentResults[rol_search.current_result_type] = response.data.results;
                rol_search.search_results_container.innerHTML = '';
                rol_search.fillNewCourseResouceResults(response);
                rol_search.showHideElementsMessages(response.data);
                rol_search.showHidePagination(response.data);
            }, 300);

            // Fade back in
            rol_search.timeout_fadein = setTimeout(() => {
                rol_search.search_results_container.classList.remove('fade-out');
            }, 350);
        }
    },

    clearTimeouts() {
        if (rol_search.timeout_fadeout !== null) {
            clearTimeout(rol_search.timeout_fadeout);
        }

        if (rol_search.timeout_fadein !== null) {
            clearTimeout(rol_search.timeout_fadein);
        }
    },

    fillNewCourseResouceResults(response) {
        for (let i = 0; i < response.data.results.length; i += 1) {
            const new_item = document.createElement('div'),
                this_data = response.data.results[i];

            new_item.classList.add('course-resource__card');
            new_item.innerHTML = rol_search.itemInnerHtml({
                label: rol_search.current_result_type === 'courses' ? 'Course' : 'Resource',
                item_xlink: rol_search.current_result_type === 'courses' ? '#courses' : '#resources',
                this_data,
            });

            rol_search.search_results_container.appendChild(new_item);
        }
    },

    getOtherResults() {
        // If there are no results for e.g. courses, check if resources has results
        // and automatically switch tabs
        const other_type = rol_search.current_result_type === 'courses' ? 'resources' : 'courses';
        rol_search.getNewCourseResourceResults(false, other_type);
    },

    nonActiveTabResults(response) {
        // If this function is called there are results only for the non-active tab
        if (response.data.count > 0) {
            const other_type = rol_search.current_result_type === 'courses' ? 'resources' : 'courses',
                other_tab = document.querySelector(`.tabs__button-search[aria-controls=search-tab-${other_type}]`);

            // Switch tab
            if (other_tab) {
                other_tab.click();
            }
        }
    },

    showHideElementsMessages(data) {
        // When no results, grey out filters, show 'no results' message
        // Show filters & tabs continually after first search with results
        const filters = document.getElementById('search__filters'),
            tabs = document.getElementById('tabs-group-search');

        if (data.count === 0) {
            rol_search.showMessage(rol_search.no_results);
            filters.classList.add('grey-out');
        } else {
            filters.classList.remove('grey-out');
            filters.classList.remove('search__hide');
            tabs.classList.remove('search__hide');
        }
    },

    showMessage(text_content) {
        const new_message = document.createElement('p');

        new_message.innerHTML = text_content;
        rol_search.search_results_container.appendChild(new_message);
    },

    itemInnerHtml({ label, item_xlink, this_data }) {
        // Construct new element
        const course_only_html = label === 'Resource' ? ''
                : `<span class="course-resource__divider"></span><span>${this_data.total_parts} Parts</span>`,
            image_style = this_data.background_image_thumbnail === null ? ''
                : `style="background-image: url(${this_data.background_image_thumbnail})"`;

        const innerHtml = `
            <a href="/courses/${this_data.slug}">
                <div class="course-resource__card-info" >
                    <div class="course-resource__card-image" ${image_style}></div>
                    <div class="course-resource__text-snippet">
                        <h4>${this_data.title}</h4>
                        <div class="course-resource__text-overflow">
                            <p>${this_data.short_description}</p>
                        </div>
                    </div>
                </div>

                <div class="course-resource__parts-bookmarks">
                    <div class="course-resource__label">
                        <svg aria-hidden="true"><use xlink:href="${item_xlink}" /></svg>
                        <span class="capitalize">${label}</span>
                        ${course_only_html}
                    </div>

                    <div class="course-resource__bookmarks">
                      <svg aria-hidden="true"><use xlink:href="#bookmarks" /></svg>
                      <span>${this_data.total_bookmarks}</span>
                    </div>
                </div>
            </a>
        `;

        return innerHtml;
    },

    setupPaginationEvents() {
        const result_area_ids = ['search-tab-courses', 'search-tab-resources'],
            pagination_buttons = ['search-prev', 'search-next'];

        for (let i = 0; i < result_area_ids.length; i += 1) {
            for (let button_i = 0; button_i < pagination_buttons.length; button_i += 1) {
                const button = document.querySelector(`#${result_area_ids[i]} .${pagination_buttons[button_i]}`);

                if (button) {
                    button.addEventListener('click', () => {
                        const direction = button_i === 0 ? -1 : 1,
                            page_param = i === 0 ? 'courses_page' : 'resources_page';

                        rol_search[page_param] += direction;
                        rol_search.getNewCourseResourceResults(false);
                    });
                }
            }
        }
    },

    showHidePagination(response_data) {
        const prev_element = rol_search.search_results_container.parentNode.querySelector('.search-prev'),
            next_element = rol_search.search_results_container.parentNode.querySelector('.search-next');

        rol_search.showHidePrevNext(response_data.previous, prev_element);
        rol_search.showHidePrevNext(response_data.next, next_element);
    },

    showHidePrevNext(data_link, element) {
        if (element && data_link) {
            element.classList.add('show');
        } else if (element) {
            element.classList.remove('show');
        }
    },

    fillNewTagsAuthorsResults(response, result_type) {
        const this_holder = rol_search.filter_holders[result_type],
            title_key = rol_search.filter_title_keys[result_type],
            current_results_by_type = rol_search.currentResults[result_type];

        if (JSON.stringify(current_results_by_type) !== JSON.stringify(response.data)) {
            rol_search.currentResults[result_type] = response.data;
            this_holder.innerHTML = '';

            if (response.data.length > 0) {
                for (let i = 0; i < response.data.length; i += 1) {
                    const this_data = response.data[i],
                        title = this_data[title_key],
                        filter_type = result_type === 'authors' ? 'author' : 'tags',
                        new_button = rol_search.makeTagAuthorButton(
                            result_type, title, filter_type, this_data,
                        );

                    this_holder.appendChild(new_button);
                }
            }
        }
    },

    makeTagAuthorButton(result_type, title, filter_type, this_data) {
        const new_button = document.createElement('button');

        new_button.setAttribute('aria-label', `Search by ${result_type}: ${title}`);
        new_button.innerHTML = title;
        new_button.classList.add('search__filter-button');
        new_button.classList.add('tags-block__tag');
        new_button.addEventListener('click', (e) => {
            rol_search.toggleFilter(e, this_data.id, filter_type);
        });

        return new_button;
    },

    toggleFilter(e, tag_id, filter_type) {
        const this_btn = e.target,
            is_active = this_btn.classList.contains('active'),
            this_filters_array = rol_search.current_tag_author_arrays[filter_type];

        if (is_active) {
            const index_filter = this_filters_array.indexOf(tag_id);
            this_btn.classList.remove('active');

            if (index_filter !== -1) {
                this_filters_array.splice(index_filter, 1);
            }
        } else {
            this_btn.classList.add('active');
            this_filters_array.push(tag_id);
        }

        rol_search.filterArrayToString(this_filters_array, filter_type);

        // Reset back to page one for different search
        rol_search.courses_page = 1;
        rol_search.resources_page = 1;
        rol_search.getNewCourseResourceResults(true);
    },

    filterArrayToString(this_filters_array, filter_type) {
        // turn an array of tags to filter by into correctly formatted string
        let new_params_string = '';

        for (let i = 0; i < this_filters_array.length; i += 1) {
            const extra_param_key = i === 0 ? `${filter_type}=` : `&${filter_type}=`;

            new_params_string += `${extra_param_key}${this_filters_array[i]}`;
        }

        rol_search.current_tag_author_params[filter_type] = new_params_string;
    },
};

module.exports = rol_search;

},{"../vendor/axios.min.js":12,"../vendor/promise-polyfill.min.js":14}],9:[function(require,module,exports){
const rol_show_hide = {
    setup() {
        const toggles = document.querySelectorAll('.show-hide-toggle'),
            close_btns = document.querySelectorAll('.close-toggle');

        for (let i = 0; i < toggles.length; i += 1) {
            const this_btn = toggles[i],
                controlled_el_id = this_btn.getAttribute('aria-controls'),
                controlled_el = document.querySelector(`#${controlled_el_id}`);
            if (controlled_el) {
                toggles[i].addEventListener('click', () => {
                    rol_show_hide.toggleClick(controlled_el, this_btn);
                });
            }
        }

        for (let c = 0; c < close_btns.length; c += 1) {
            const close_btn = close_btns[c],
                controlled_el_id = close_btn.getAttribute('aria-controls'),
                controlled_el = document.querySelector(`#${controlled_el_id}`),
                related_toggle_id = close_btn.getAttribute('data-related-toggle'),
                related_toggle = document.querySelector(`#${related_toggle_id}`);

            if (controlled_el) {
                close_btns[c].addEventListener('click', () => {
                    controlled_el.classList.remove('show');

                    if (related_toggle) {
                        related_toggle.setAttribute('aria-expanded', 'false');
                    }
                });
            }
        }
    },

    toggleClick(controlled_el, this_btn) {
        const is_expanded = this_btn.getAttribute('aria-expanded') === 'true';

        if (is_expanded) {
            this_btn.setAttribute('aria-expanded', 'false');
            controlled_el.classList.remove('show');
        } else {
            this_btn.setAttribute('aria-expanded', 'true');
            controlled_el.classList.add('show');

            // Resize event ensures the slider and slides are sized correctly
            const false_resize = document.createEvent('HTMLEvents');
            false_resize.initEvent('resize', true, false);
            window.dispatchEvent(false_resize);
        }
    },
};

module.exports = rol_show_hide;

},{}],10:[function(require,module,exports){
// https://pawelgrzybek.github.io/siema/
const Siema = require('../vendor/siema.min.js'),
    debounce = require('./debounce.js');

const rol_sliders = {
    std_slider_instances: [],

    home_theme_slider: null,
    home_theme_original_markup: null,
    home_theme_slider_is_siema: false,
    home_theme_slider_opts: {
        selector: '#siema__home-theme',
        perPage: {
            0: 2,
            401: 3,
            499: 4,
            767: 6,
        },
        duration: 450,
        easing: 'ease-in-out',
        onInit: () => { rol_sliders.setAriaAttributes(-1); },
        onChange: () => {
            rol_sliders.setAriaAttributes(-1);
        },
    },

    setup() {
        // Setup 'standard' sliders
        const std_sliders = document.querySelectorAll('.slider:not(.slider__special) ul');

        for (let i = 0; i < std_sliders.length; i += 1) {
            const this_slider = std_sliders[i],
                slider_id = `slider-${i}`,
                slider_parent = this_slider.parentNode,
                slider_slides = this_slider.querySelectorAll('li'),
                per_page_config = rol_sliders.setupStandardMultiAcross(slider_parent);

            this_slider.id = slider_id;
            this_slider.setAttribute('data-index', i);

            const this_instance = new Siema({
                selector: `#${slider_id}`,
                duration: 450,
                easing: 'ease-in-out',
                perPage: per_page_config,
                onInit: () => { rol_sliders.setAriaAttributes(i); },
                onChange: () => {
                    rol_sliders.setAriaAttributes(i);
                    rol_sliders.resetActiveButton(slider_parent, i);
                },
            });

            rol_sliders.std_slider_instances.push(this_instance);
            rol_sliders.setupButtons(i, slider_parent, slider_slides);
        }

        // Home - theme slider - check if the slider should be setup only for mobile
        // (user logged in, 'jump to' card in lefthand column on desktop), or normally
        rol_sliders.checkHomeThemeToggle();

        window.addEventListener('resize', rol_sliders.onResize);
    },

    onResize: debounce(() => {
        // (i = -1 is to include the special-case home-theme slider)
        for (let i = -1; i < rol_sliders.std_slider_instances.length; i += 1) {
            rol_sliders.setAriaAttributes(i);
        }
    }, 500),

    setupStandardMultiAcross(slider_parent) {
        // Standard multi-across will be 3 on desktop
        // (Home page theme slider is still handled separately - custom config)
        const slider_holder_classes = slider_parent.classList;
        let per_page_config = {};

        if (slider_holder_classes.contains('slider__multi-across')) {
            per_page_config = {
                499: 2,
                768: 3,
            };
        }

        return per_page_config;
    },

    setupButtons(slider_index, slider_parent, slider_slides) {
        const buttons = slider_parent.querySelector('.slider__buttons');

        for (let i = 1; i <= slider_slides.length; i += 1) {
            // All sliders - set index attribute per slide
            const slide_index = (i - 1),
                this_slide = slider_slides[slide_index];

            this_slide.setAttribute('data-slide-index', slide_index);

            // Add 'next' & 'prev' tab links on slides
            rol_sliders.addNextPrev(slider_index, this_slide, slide_index, slider_slides.length);

            // Sliders with 'dot' nav buttons
            if (buttons) {
                const new_button = document.createElement('button');
                new_button.setAttribute('aria-label', `Show slide ${i} of ${slider_slides.length}`);
                new_button.setAttribute('data-slide-index', slide_index);
                new_button.setAttribute('data-slider-index', slider_index);
                new_button.innerHTML = `<span>${i}</span>`;

                if (i === 1) {
                    new_button.classList.add('active');
                }

                buttons.appendChild(new_button);
                new_button.addEventListener('click', rol_sliders.sliderButtonClick);
            }
        }
    },

    sliderButtonClick() {
        const this_slider_index = this.getAttribute('data-slider-index'),
            this_slide_index = this.getAttribute('data-slide-index');

        if (this_slider_index && this_slide_index) {
            const this_slider_instance = rol_sliders.std_slider_instances[
                parseInt(this_slider_index, 10)
            ];

            this_slider_instance.goTo(parseInt(this_slide_index, 10));
        }
    },

    addNextPrev(slider_index, this_slide, slide_index, total_slides) {
        // Allow keyboard navigation through slider. Next / prev buttons will
        // show on focus only and not move focus away from current position in slides
        if (slide_index !== 0) {
            const prev_button = rol_sliders.setupNavBtn('Previous slide', 'slider__prev', slider_index);

            try { // Modern browsers
                this_slide.prepend(prev_button);
            } catch (e) { // IE11
                this_slide.appendChild(prev_button);
            }
        }

        if (slide_index !== total_slides - 1) {
            const next_button = rol_sliders.setupNavBtn('Next slide', 'slider__next', slider_index);
            this_slide.appendChild(next_button);
        }
    },

    setupNavBtn(aria_label, direction_class, slider_index) {
        const this_button = document.createElement('button');

        this_button.setAttribute('aria-label', aria_label);
        // IE11 requires class adding to be longhand!
        this_button.classList.add('focus-visible');
        this_button.classList.add(direction_class);
        this_button.addEventListener('click', (e) => {
            rol_sliders.nextPrevClick(e, slider_index);
        });

        return this_button;
    },

    nextPrevClick(e, slider_index) {
        const direction_next = e.target.classList.contains('slider__next'),
            this_slider_instance = slider_index === -1 ? rol_sliders.home_theme_slider
                : rol_sliders.std_slider_instances[parseInt(slider_index, 10)];

        if (direction_next) {
            this_slider_instance.next();
        } else {
            this_slider_instance.prev();
        }
    },

    resetActiveButton(slider_holder, slider_index) {
        setTimeout(() => {
            const this_slider_instance = rol_sliders.std_slider_instances[slider_index];

            if (slider_holder) {
                const button_set = slider_holder.querySelectorAll('.slider__buttons button'),
                    current_index = this_slider_instance.currentSlide;

                for (let i = 0; i < button_set.length; i += 1) {
                    if (current_index === i) {
                        button_set[i].classList.add('active');
                    } else {
                        button_set[i].classList.remove('active');
                    }
                }
            }
        }, 0);
    },

    setAriaAttributes(slider_index) {
        // Slides should be aria-hidden when not visible so slider has the same
        // functionality for mouse/keyboard/keyboard+aria (+ avoid position shift)
        setTimeout(() => {
            const this_slider_instance = slider_index === -1 ? rol_sliders.home_theme_slider
                    : rol_sliders.std_slider_instances[slider_index],
                this_holder_id = slider_index === -1 ? 'siema__home-theme' : `slider-${slider_index}`,
                slide_set = document.querySelectorAll(`#${this_holder_id} li`);
            let has_hidden_slides = false;

            for (let i = 0; i < slide_set.length; i += 1) {
                const this_slide = slide_set[i],
                    current_slide_plus_multi_across = this_slider_instance.currentSlide
                        + this_slider_instance.perPage;

                if (i >= this_slider_instance.currentSlide
                    && i < current_slide_plus_multi_across) {
                    this_slide.setAttribute('aria-hidden', false);
                    rol_sliders.setTabIndexes({ slide: this_slide, value: 0 });
                } else {
                    this_slide.setAttribute('aria-hidden', true);
                    rol_sliders.setTabIndexes({ slide: this_slide, value: -1 });
                    has_hidden_slides = true;
                }
            }

            rol_sliders.showHideKeyboardNav({ show: has_hidden_slides, this_holder_id });
        }, 0);
    },

    showHideKeyboardNav({ show, this_holder_id }) {
        // Hide the keyboard nav buttons when all slides are shown & no need to navigate
        const access_links = document.querySelectorAll(`#${this_holder_id} .focus-visible`);

        for (let i = 0; i < access_links.length; i += 1) {
            if (show) {
                access_links[i].classList.remove('hide-link');
            } else {
                access_links[i].classList.add('hide-link');
            }
        }
    },

    setTabIndexes({ slide, value }) {
        // Set tabindex to -1 for links & buttons which should be hidden
        const inner_links_buttons = slide.querySelectorAll('a, button');

        for (let i = 0; i < inner_links_buttons.length; i += 1) {
            inner_links_buttons[i].setAttribute('tabindex', value);
        }
    },

    checkHomeThemeToggle() {
        const home_theme_slider_el = document.getElementById('siema__home-theme');

        // If home theme slider exists on this page, setup or make setup/destroy depend
        // on screen width
        if (home_theme_slider_el) {
            const jump_to_section_visible = /non-slide-desktop/.test(home_theme_slider_el.classList);

            rol_sliders.setupHomeThemeNav(home_theme_slider_el);
            rol_sliders.home_theme_original_markup = home_theme_slider_el.innerHTML;

            if (jump_to_section_visible) {
                window.addEventListener('resize', () => {
                    rol_sliders.homeThemeToggleOnScreensize();
                });

                rol_sliders.homeThemeToggleOnScreensize();
            } else {
                rol_sliders.home_theme_slider = new Siema(rol_sliders.home_theme_slider_opts);
                rol_sliders.home_theme_slider_is_siema = true;
            }
        }
    },

    setupHomeThemeNav(home_theme_slider_el) {
        // Set up nav buttons once only (save these buttons with original markup, display none)
        const home_theme_slides = home_theme_slider_el.querySelectorAll('li');

        for (let i = 0; i < home_theme_slides.length; i += 1) {
            const this_slide = home_theme_slides[i];
            rol_sliders.addNextPrev(-1, this_slide, i, home_theme_slides.length);
        }
    },

    homeThemeToggleOnScreensize() {
        if (window.innerWidth > 767 && rol_sliders.home_theme_slider_is_siema) {
            // Destroy siema instance. Param restore markup from Siema does not work on IE11
            // So this is done manually
            rol_sliders.home_theme_slider.destroy(false);
            rol_sliders.home_theme_slider_is_siema = false;

            setTimeout(() => {
                rol_sliders.homeThemeRestoreMarkup();
            }, 0);
        } else if (window.innerWidth < 768 && !rol_sliders.home_theme_slider_is_siema) {
            // Setup / re-setup siema instance
            rol_sliders.home_theme_slider = new Siema(rol_sliders.home_theme_slider_opts);
            rol_sliders.home_theme_slider_is_siema = true;
        }
    },

    homeThemeRestoreMarkup() {
        document.getElementById('siema__home-theme').innerHTML = rol_sliders.home_theme_original_markup;
    },
};

module.exports = rol_sliders;

},{"../vendor/siema.min.js":15,"./debounce.js":3}],11:[function(require,module,exports){
const rol_tabs = {
    setup() {
        const tab_groups = document.getElementsByClassName('tabs__group');

        for (let i = 0; i < tab_groups.length; i += 1) {
            const tabs_holder = tab_groups[i],
                tab_buttons = tabs_holder.querySelectorAll('.tabs__button');

            for (let button_index = 0; button_index < tab_buttons.length; button_index += 1) {
                const associated_id = tab_buttons[button_index].getAttribute('aria-controls');

                // Set tab button click events by tab group
                tab_buttons[button_index].addEventListener('click', (e) => {
                    if (e.target.getAttribute('aria-expanded') !== true) {
                        rol_tabs.showHideTabs(tabs_holder, associated_id);
                    }
                });
            }
        }

        rol_tabs.checkStoredTabs();
    },

    showHideTabs(tabs_holder, associated_id) {
        const tab_group_buttons = tabs_holder.querySelectorAll('.tabs__button'),
            tab_group_contents = tabs_holder.querySelectorAll('.tabs__content');

        for (let i = 0; i < tab_group_buttons.length; i += 1) {
            const this_tab_contents = tab_group_contents[i];

            if (this_tab_contents) {
                const this_content_id = this_tab_contents.id;

                if (this_content_id === associated_id) {
                    tab_group_buttons[i].setAttribute('aria-expanded', true);
                    this_tab_contents.classList.remove('tabs__hide');
                } else {
                    tab_group_buttons[i].setAttribute('aria-expanded', false);
                    this_tab_contents.classList.add('tabs__hide');
                }
            }
        }

        rol_tabs.storeCurrentTab(associated_id);
        rol_tabs.forceSliderResize();
    },

    forceSliderResize() {
        // Resize event ensures the slider and slides are sized correctly
        const false_resize = document.createEvent('HTMLEvents');
        false_resize.initEvent('resize', true, false);
        window.dispatchEvent(false_resize);
    },

    storeCurrentTab(current_content_id) {
        // Store current content id for tab group on page
        // This will only work correctly for pages with a single tab group
        // - should new page tpes be added an update may be needed
        if (rol_tabs.sessionStorageAvailable) {
            window.sessionStorage.setItem('rol_current_tab', current_content_id);
        }
    },

    checkStoredTabs() {
        // Check for stored active tab value
        let tab_id = null;
        if (rol_tabs.sessionStorageAvailable) {
            tab_id = window.sessionStorage.getItem('rol_current_tab');
            const active_tab = document.getElementById(tab_id);

            if (active_tab) {
                let tabs_holder = active_tab.parentNode;

                if (!tabs_holder.classList.contains('tabs__group')) {
                    tabs_holder = active_tab.parentNode.parentNode;
                }
                rol_tabs.showHideTabs(tabs_holder, tab_id);
            } else {
                // If stored value doesn't match an element on the page
                rol_tabs.showFirstTab();
            }
        } else {
            rol_tabs.showFirstTab();
        }
    },

    showFirstTab() {
        // Show first tab to start
        const tab_groups = document.getElementsByClassName('tabs__group');

        for (let i = 0; i < tab_groups.length; i += 1) {
            const tabs_holder = tab_groups[i],
                tab_first_button = tabs_holder.querySelector('.tabs__button');

            if (tab_first_button) {
                const associated_id = tab_first_button.getAttribute('aria-controls');
                rol_tabs.showHideTabs(tabs_holder, associated_id);
            }
        }
    },

    sessionStorageAvailable() {
        try {
            const storage = window.sessionStorage,
                x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        } catch (e) {
            return false;
        }
    },
};

module.exports = rol_tabs;

},{}],12:[function(require,module,exports){
(function (process){
/* axios v0.19.0-beta.1 | (c) 2018 by Matt Zabriskie */
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.axios=t():e.axios=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){e.exports=n(1)},function(e,t,n){"use strict";function r(e){var t=new i(e),n=s(i.prototype.request,t);return o.extend(n,i.prototype,t),o.extend(n,t),n}var o=n(2),s=n(3),i=n(5),a=n(22),u=n(11),c=r(u);c.Axios=i,c.create=function(e){return r(a(c.defaults,e))},c.Cancel=n(23),c.CancelToken=n(24),c.isCancel=n(10),c.all=function(e){return Promise.all(e)},c.spread=n(25),e.exports=c,e.exports.default=c},function(e,t,n){"use strict";function r(e){return"[object Array]"===j.call(e)}function o(e){return"[object ArrayBuffer]"===j.call(e)}function s(e){return"undefined"!=typeof FormData&&e instanceof FormData}function i(e){var t;return t="undefined"!=typeof ArrayBuffer&&ArrayBuffer.isView?ArrayBuffer.isView(e):e&&e.buffer&&e.buffer instanceof ArrayBuffer}function a(e){return"string"==typeof e}function u(e){return"number"==typeof e}function c(e){return"undefined"==typeof e}function f(e){return null!==e&&"object"==typeof e}function p(e){return"[object Date]"===j.call(e)}function d(e){return"[object File]"===j.call(e)}function l(e){return"[object Blob]"===j.call(e)}function h(e){return"[object Function]"===j.call(e)}function m(e){return f(e)&&h(e.pipe)}function y(e){return"undefined"!=typeof URLSearchParams&&e instanceof URLSearchParams}function g(e){return e.replace(/^\s*/,"").replace(/\s*$/,"")}function x(){return("undefined"==typeof navigator||"ReactNative"!==navigator.product&&"NativeScript"!==navigator.product&&"NS"!==navigator.product)&&("undefined"!=typeof window&&"undefined"!=typeof document)}function v(e,t){if(null!==e&&"undefined"!=typeof e)if("object"!=typeof e&&(e=[e]),r(e))for(var n=0,o=e.length;n<o;n++)t.call(null,e[n],n,e);else for(var s in e)Object.prototype.hasOwnProperty.call(e,s)&&t.call(null,e[s],s,e)}function w(){function e(e,n){"object"==typeof t[n]&&"object"==typeof e?t[n]=w(t[n],e):t[n]=e}for(var t={},n=0,r=arguments.length;n<r;n++)v(arguments[n],e);return t}function b(){function e(e,n){"object"==typeof t[n]&&"object"==typeof e?t[n]=b(t[n],e):"object"==typeof e?t[n]=b({},e):t[n]=e}for(var t={},n=0,r=arguments.length;n<r;n++)v(arguments[n],e);return t}function E(e,t,n){return v(t,function(t,r){n&&"function"==typeof t?e[r]=S(t,n):e[r]=t}),e}var S=n(3),R=n(4),j=Object.prototype.toString;e.exports={isArray:r,isArrayBuffer:o,isBuffer:R,isFormData:s,isArrayBufferView:i,isString:a,isNumber:u,isObject:f,isUndefined:c,isDate:p,isFile:d,isBlob:l,isFunction:h,isStream:m,isURLSearchParams:y,isStandardBrowserEnv:x,forEach:v,merge:w,deepMerge:b,extend:E,trim:g}},function(e,t){"use strict";e.exports=function(e,t){return function(){for(var n=new Array(arguments.length),r=0;r<n.length;r++)n[r]=arguments[r];return e.apply(t,n)}}},function(e,t){/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
e.exports=function(e){return null!=e&&null!=e.constructor&&"function"==typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)}},function(e,t,n){"use strict";function r(e){this.defaults=e,this.interceptors={request:new i,response:new i}}var o=n(2),s=n(6),i=n(7),a=n(8),u=n(22);r.prototype.request=function(e){"string"==typeof e?(e=arguments[1]||{},e.url=arguments[0]):e=e||{},e=u(this.defaults,e),e.method=e.method?e.method.toLowerCase():"get";var t=[a,void 0],n=Promise.resolve(e);for(this.interceptors.request.forEach(function(e){t.unshift(e.fulfilled,e.rejected)}),this.interceptors.response.forEach(function(e){t.push(e.fulfilled,e.rejected)});t.length;)n=n.then(t.shift(),t.shift());return n},r.prototype.getUri=function(e){return e=u(this.defaults,e),s(e.url,e.params,e.paramsSerializer).replace(/^\?/,"")},o.forEach(["delete","get","head","options"],function(e){r.prototype[e]=function(t,n){return this.request(o.merge(n||{},{method:e,url:t}))}}),o.forEach(["post","put","patch"],function(e){r.prototype[e]=function(t,n,r){return this.request(o.merge(r||{},{method:e,url:t,data:n}))}}),e.exports=r},function(e,t,n){"use strict";function r(e){return encodeURIComponent(e).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}var o=n(2);e.exports=function(e,t,n){if(!t)return e;var s;if(n)s=n(t);else if(o.isURLSearchParams(t))s=t.toString();else{var i=[];o.forEach(t,function(e,t){null!==e&&"undefined"!=typeof e&&(o.isArray(e)?t+="[]":e=[e],o.forEach(e,function(e){o.isDate(e)?e=e.toISOString():o.isObject(e)&&(e=JSON.stringify(e)),i.push(r(t)+"="+r(e))}))}),s=i.join("&")}return s&&(e+=(e.indexOf("?")===-1?"?":"&")+s),e}},function(e,t,n){"use strict";function r(){this.handlers=[]}var o=n(2);r.prototype.use=function(e,t){return this.handlers.push({fulfilled:e,rejected:t}),this.handlers.length-1},r.prototype.eject=function(e){this.handlers[e]&&(this.handlers[e]=null)},r.prototype.forEach=function(e){o.forEach(this.handlers,function(t){null!==t&&e(t)})},e.exports=r},function(e,t,n){"use strict";function r(e){e.cancelToken&&e.cancelToken.throwIfRequested()}var o=n(2),s=n(9),i=n(10),a=n(11),u=n(20),c=n(21);e.exports=function(e){r(e),e.baseURL&&!u(e.url)&&(e.url=c(e.baseURL,e.url)),e.headers=e.headers||{},e.data=s(e.data,e.headers,e.transformRequest),e.headers=o.merge(e.headers.common||{},e.headers[e.method]||{},e.headers||{}),o.forEach(["delete","get","head","post","put","patch","common"],function(t){delete e.headers[t]});var t=e.adapter||a.adapter;return t(e).then(function(t){return r(e),t.data=s(t.data,t.headers,e.transformResponse),t},function(t){return i(t)||(r(e),t&&t.response&&(t.response.data=s(t.response.data,t.response.headers,e.transformResponse))),Promise.reject(t)})}},function(e,t,n){"use strict";var r=n(2);e.exports=function(e,t,n){return r.forEach(n,function(n){e=n(e,t)}),e}},function(e,t){"use strict";e.exports=function(e){return!(!e||!e.__CANCEL__)}},function(e,t,n){"use strict";function r(e,t){!s.isUndefined(e)&&s.isUndefined(e["Content-Type"])&&(e["Content-Type"]=t)}function o(){var e;return"undefined"!=typeof process&&"[object process]"===Object.prototype.toString.call(process)?e=n(13):"undefined"!=typeof XMLHttpRequest&&(e=n(13)),e}var s=n(2),i=n(12),a={"Content-Type":"application/x-www-form-urlencoded"},u={adapter:o(),transformRequest:[function(e,t){return i(t,"Accept"),i(t,"Content-Type"),s.isFormData(e)||s.isArrayBuffer(e)||s.isBuffer(e)||s.isStream(e)||s.isFile(e)||s.isBlob(e)?e:s.isArrayBufferView(e)?e.buffer:s.isURLSearchParams(e)?(r(t,"application/x-www-form-urlencoded;charset=utf-8"),e.toString()):s.isObject(e)?(r(t,"application/json;charset=utf-8"),JSON.stringify(e)):e}],transformResponse:[function(e){if("string"==typeof e)try{e=JSON.parse(e)}catch(e){}return e}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,validateStatus:function(e){return e>=200&&e<300}};u.headers={common:{Accept:"application/json, text/plain, */*"}},s.forEach(["delete","get","head"],function(e){u.headers[e]={}}),s.forEach(["post","put","patch"],function(e){u.headers[e]=s.merge(a)}),e.exports=u},function(e,t,n){"use strict";var r=n(2);e.exports=function(e,t){r.forEach(e,function(n,r){r!==t&&r.toUpperCase()===t.toUpperCase()&&(e[t]=n,delete e[r])})}},function(e,t,n){"use strict";var r=n(2),o=n(14),s=n(6),i=n(17),a=n(18),u=n(15);e.exports=function(e){return new Promise(function(t,c){var f=e.data,p=e.headers;r.isFormData(f)&&delete p["Content-Type"];var d=new XMLHttpRequest;if(e.auth){var l=e.auth.username||"",h=e.auth.password||"";p.Authorization="Basic "+btoa(l+":"+h)}if(d.open(e.method.toUpperCase(),s(e.url,e.params,e.paramsSerializer),!0),d.timeout=e.timeout,d.onreadystatechange=function(){if(d&&4===d.readyState&&(0!==d.status||d.responseURL&&0===d.responseURL.indexOf("file:"))){var n="getAllResponseHeaders"in d?i(d.getAllResponseHeaders()):null,r=e.responseType&&"text"!==e.responseType?d.response:d.responseText,s={data:r,status:d.status,statusText:d.statusText,headers:n,config:e,request:d};o(t,c,s),d=null}},d.onabort=function(){d&&(c(u("Request aborted",e,"ECONNABORTED",d)),d=null)},d.onerror=function(){c(u("Network Error",e,null,d)),d=null},d.ontimeout=function(){c(u("timeout of "+e.timeout+"ms exceeded",e,"ECONNABORTED",d)),d=null},r.isStandardBrowserEnv()){var m=n(19),y=(e.withCredentials||a(e.url))&&e.xsrfCookieName?m.read(e.xsrfCookieName):void 0;y&&(p[e.xsrfHeaderName]=y)}if("setRequestHeader"in d&&r.forEach(p,function(e,t){"undefined"==typeof f&&"content-type"===t.toLowerCase()?delete p[t]:d.setRequestHeader(t,e)}),e.withCredentials&&(d.withCredentials=!0),e.responseType)try{d.responseType=e.responseType}catch(t){if("json"!==e.responseType)throw t}"function"==typeof e.onDownloadProgress&&d.addEventListener("progress",e.onDownloadProgress),"function"==typeof e.onUploadProgress&&d.upload&&d.upload.addEventListener("progress",e.onUploadProgress),e.cancelToken&&e.cancelToken.promise.then(function(e){d&&(d.abort(),c(e),d=null)}),void 0===f&&(f=null),d.send(f)})}},function(e,t,n){"use strict";var r=n(15);e.exports=function(e,t,n){var o=n.config.validateStatus;!o||o(n.status)?e(n):t(r("Request failed with status code "+n.status,n.config,null,n.request,n))}},function(e,t,n){"use strict";var r=n(16);e.exports=function(e,t,n,o,s){var i=new Error(e);return r(i,t,n,o,s)}},function(e,t){"use strict";e.exports=function(e,t,n,r,o){return e.config=t,n&&(e.code=n),e.request=r,e.response=o,e.toJSON=function(){return{message:this.message,name:this.name,description:this.description,number:this.number,fileName:this.fileName,lineNumber:this.lineNumber,columnNumber:this.columnNumber,stack:this.stack,config:this.config,code:this.code}},e}},function(e,t,n){"use strict";var r=n(2),o=["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"];e.exports=function(e){var t,n,s,i={};return e?(r.forEach(e.split("\n"),function(e){if(s=e.indexOf(":"),t=r.trim(e.substr(0,s)).toLowerCase(),n=r.trim(e.substr(s+1)),t){if(i[t]&&o.indexOf(t)>=0)return;"set-cookie"===t?i[t]=(i[t]?i[t]:[]).concat([n]):i[t]=i[t]?i[t]+", "+n:n}}),i):i}},function(e,t,n){"use strict";var r=n(2);e.exports=r.isStandardBrowserEnv()?function(){function e(e){var t=e;return n&&(o.setAttribute("href",t),t=o.href),o.setAttribute("href",t),{href:o.href,protocol:o.protocol?o.protocol.replace(/:$/,""):"",host:o.host,search:o.search?o.search.replace(/^\?/,""):"",hash:o.hash?o.hash.replace(/^#/,""):"",hostname:o.hostname,port:o.port,pathname:"/"===o.pathname.charAt(0)?o.pathname:"/"+o.pathname}}var t,n=/(msie|trident)/i.test(navigator.userAgent),o=document.createElement("a");return t=e(window.location.href),function(n){var o=r.isString(n)?e(n):n;return o.protocol===t.protocol&&o.host===t.host}}():function(){return function(){return!0}}()},function(e,t,n){"use strict";var r=n(2);e.exports=r.isStandardBrowserEnv()?function(){return{write:function(e,t,n,o,s,i){var a=[];a.push(e+"="+encodeURIComponent(t)),r.isNumber(n)&&a.push("expires="+new Date(n).toGMTString()),r.isString(o)&&a.push("path="+o),r.isString(s)&&a.push("domain="+s),i===!0&&a.push("secure"),document.cookie=a.join("; ")},read:function(e){var t=document.cookie.match(new RegExp("(^|;\\s*)("+e+")=([^;]*)"));return t?decodeURIComponent(t[3]):null},remove:function(e){this.write(e,"",Date.now()-864e5)}}}():function(){return{write:function(){},read:function(){return null},remove:function(){}}}()},function(e,t){"use strict";e.exports=function(e){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e)}},function(e,t){"use strict";e.exports=function(e,t){return t?e.replace(/\/+$/,"")+"/"+t.replace(/^\/+/,""):e}},function(e,t,n){"use strict";var r=n(2);e.exports=function(e,t){t=t||{};var n={};return r.forEach(["url","method","params","data"],function(e){"undefined"!=typeof t[e]&&(n[e]=t[e])}),r.forEach(["headers","auth","proxy"],function(o){r.isObject(t[o])?n[o]=r.deepMerge(e[o],t[o]):"undefined"!=typeof t[o]?n[o]=t[o]:r.isObject(e[o])?n[o]=r.deepMerge(e[o]):"undefined"!=typeof e[o]&&(n[o]=e[o])}),r.forEach(["baseURL","transformRequest","transformResponse","paramsSerializer","timeout","withCredentials","adapter","responseType","xsrfCookieName","xsrfHeaderName","onUploadProgress","onDownloadProgress","maxContentLength","validateStatus","maxRedirects","httpAgent","httpsAgent","cancelToken","socketPath"],function(r){"undefined"!=typeof t[r]?n[r]=t[r]:"undefined"!=typeof e[r]&&(n[r]=e[r])}),n}},function(e,t){"use strict";function n(e){this.message=e}n.prototype.toString=function(){return"Cancel"+(this.message?": "+this.message:"")},n.prototype.__CANCEL__=!0,e.exports=n},function(e,t,n){"use strict";function r(e){if("function"!=typeof e)throw new TypeError("executor must be a function.");var t;this.promise=new Promise(function(e){t=e});var n=this;e(function(e){n.reason||(n.reason=new o(e),t(n.reason))})}var o=n(23);r.prototype.throwIfRequested=function(){if(this.reason)throw this.reason},r.source=function(){var e,t=new r(function(t){e=t});return{token:t,cancel:e}},e.exports=r},function(e,t){"use strict";e.exports=function(e){return function(t){return e.apply(null,t)}}}])});


}).call(this,require('_process'))

},{"_process":1}],13:[function(require,module,exports){
// https://github.com/RadLikeWhoa/Countable
!function(t){let n=[];const e=Array.prototype.forEach;function r(t){const n=[];let e=0;const r=t.length;for(;e<r;){const o=t.charCodeAt(e++);if(o>=55296&&o<=56319&&e<r){const r=t.charCodeAt(e++);56320==(64512&r)?n.push(((1023&o)<<10)+(1023&r)+65536):(n.push(o),e--)}else n.push(o)}return n}function o(t,n){const e=Object.prototype.toString.call(t),r="string"==typeof t||"[object NodeList]"===e||"[object HTMLCollection]"===e||1===t.nodeType,o="function"==typeof n;return r||console.error("Countable: Not a valid target"),o||console.error("Countable: Not a valid callback function"),r&&o}function c(t,n){let o=""+("string"==typeof t?t:"value"in t?t.value:t.textContent);(n=n||{}).stripTags&&(o=o.replace(/<\/?[a-z][^>]*>/gi,"")),n.ignore&&e.call(n.ignore,function(t){o=o.replace(t,"")});const c=o.trim();return{paragraphs:c?(c.match(n.hardReturns?/\n{2,}/g:/\n+/g)||[]).length+1:0,sentences:c?(c.match(/[.?!…]+./g)||[]).length+1:0,words:c?(c.replace(/['";:,.?¿\-!¡]+/g,"").match(/\S+/g)||[]).length:0,characters:c?r(c.replace(/\s/g,"")).length:0,all:r(o).length}}const i={on:function(t,r,i){if(o(t,r))return Array.isArray(t)||(t=[t]),e.call(t,function(t){const e=function(){r.call(t,c(t,i))};n.push({element:t,handler:e}),e(),t.addEventListener("input",e)}),this},off:function(t){if(o(t,function(){}))return Array.isArray(t)||(t=[t]),n.filter(function(n){return-1!==t.indexOf(n.element)}).forEach(function(t){t.element.removeEventListener("input",t.handler)}),n=n.filter(function(n){return-1===t.indexOf(n.element)}),this},count:function(t,n,r){if(o(t,n))return Array.isArray(t)||(t=[t]),e.call(t,function(t){n.call(t,c(t,r))}),this},enabled:function(t){return void 0===t.length&&(t=[t]),n.filter(function(n){return-1!==t.indexOf(n.element)}).length===t.length}};"object"==typeof exports?module.exports=i:"function"==typeof define&&define.amd?define(function(){return i}):t.Countable=i}(this);

},{}],14:[function(require,module,exports){
(function (process,global){
//https://cdn.jsdelivr.net/npm/es6-promise/dist/es6-promise.auto.min.js
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.ES6Promise=e()}(this,function(){"use strict";function t(t){var e=typeof t;return null!==t&&("object"===e||"function"===e)}function e(t){return"function"==typeof t}function n(t){B=t}function r(t){G=t}function o(){return function(){return process.nextTick(a)}}function i(){return"undefined"!=typeof z?function(){z(a)}:c()}function s(){var t=0,e=new J(a),n=document.createTextNode("");return e.observe(n,{characterData:!0}),function(){n.data=t=++t%2}}function u(){var t=new MessageChannel;return t.port1.onmessage=a,function(){return t.port2.postMessage(0)}}function c(){var t=setTimeout;return function(){return t(a,1)}}function a(){for(var t=0;t<W;t+=2){var e=V[t],n=V[t+1];e(n),V[t]=void 0,V[t+1]=void 0}W=0}function f(){try{var t=Function("return this")().require("vertx");return z=t.runOnLoop||t.runOnContext,i()}catch(e){return c()}}function l(t,e){var n=this,r=new this.constructor(p);void 0===r[Z]&&O(r);var o=n._state;if(o){var i=arguments[o-1];G(function(){return P(o,r,i,n._result)})}else E(n,r,t,e);return r}function h(t){var e=this;if(t&&"object"==typeof t&&t.constructor===e)return t;var n=new e(p);return g(n,t),n}function p(){}function v(){return new TypeError("You cannot resolve a promise with itself")}function d(){return new TypeError("A promises callback cannot return that same promise.")}function _(t){try{return t.then}catch(e){return nt.error=e,nt}}function y(t,e,n,r){try{t.call(e,n,r)}catch(o){return o}}function m(t,e,n){G(function(t){var r=!1,o=y(n,e,function(n){r||(r=!0,e!==n?g(t,n):S(t,n))},function(e){r||(r=!0,j(t,e))},"Settle: "+(t._label||" unknown promise"));!r&&o&&(r=!0,j(t,o))},t)}function b(t,e){e._state===tt?S(t,e._result):e._state===et?j(t,e._result):E(e,void 0,function(e){return g(t,e)},function(e){return j(t,e)})}function w(t,n,r){n.constructor===t.constructor&&r===l&&n.constructor.resolve===h?b(t,n):r===nt?(j(t,nt.error),nt.error=null):void 0===r?S(t,n):e(r)?m(t,n,r):S(t,n)}function g(e,n){e===n?j(e,v()):t(n)?w(e,n,_(n)):S(e,n)}function A(t){t._onerror&&t._onerror(t._result),T(t)}function S(t,e){t._state===$&&(t._result=e,t._state=tt,0!==t._subscribers.length&&G(T,t))}function j(t,e){t._state===$&&(t._state=et,t._result=e,G(A,t))}function E(t,e,n,r){var o=t._subscribers,i=o.length;t._onerror=null,o[i]=e,o[i+tt]=n,o[i+et]=r,0===i&&t._state&&G(T,t)}function T(t){var e=t._subscribers,n=t._state;if(0!==e.length){for(var r=void 0,o=void 0,i=t._result,s=0;s<e.length;s+=3)r=e[s],o=e[s+n],r?P(n,r,o,i):o(i);t._subscribers.length=0}}function M(t,e){try{return t(e)}catch(n){return nt.error=n,nt}}function P(t,n,r,o){var i=e(r),s=void 0,u=void 0,c=void 0,a=void 0;if(i){if(s=M(r,o),s===nt?(a=!0,u=s.error,s.error=null):c=!0,n===s)return void j(n,d())}else s=o,c=!0;n._state!==$||(i&&c?g(n,s):a?j(n,u):t===tt?S(n,s):t===et&&j(n,s))}function x(t,e){try{e(function(e){g(t,e)},function(e){j(t,e)})}catch(n){j(t,n)}}function C(){return rt++}function O(t){t[Z]=rt++,t._state=void 0,t._result=void 0,t._subscribers=[]}function k(){return new Error("Array Methods must be provided an Array")}function F(t){return new ot(this,t).promise}function Y(t){var e=this;return new e(U(t)?function(n,r){for(var o=t.length,i=0;i<o;i++)e.resolve(t[i]).then(n,r)}:function(t,e){return e(new TypeError("You must pass an array to race."))})}function q(t){var e=this,n=new e(p);return j(n,t),n}function D(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}function K(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}function L(){var t=void 0;if("undefined"!=typeof global)t=global;else if("undefined"!=typeof self)t=self;else try{t=Function("return this")()}catch(e){throw new Error("polyfill failed because global object is unavailable in this environment")}var n=t.Promise;if(n){var r=null;try{r=Object.prototype.toString.call(n.resolve())}catch(e){}if("[object Promise]"===r&&!n.cast)return}t.Promise=it}var N=void 0;N=Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)};var U=N,W=0,z=void 0,B=void 0,G=function(t,e){V[W]=t,V[W+1]=e,W+=2,2===W&&(B?B(a):X())},H="undefined"!=typeof window?window:void 0,I=H||{},J=I.MutationObserver||I.WebKitMutationObserver,Q="undefined"==typeof self&&"undefined"!=typeof process&&"[object process]"==={}.toString.call(process),R="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel,V=new Array(1e3),X=void 0;X=Q?o():J?s():R?u():void 0===H&&"function"==typeof require?f():c();var Z=Math.random().toString(36).substring(2),$=void 0,tt=1,et=2,nt={error:null},rt=0,ot=function(){function t(t,e){this._instanceConstructor=t,this.promise=new t(p),this.promise[Z]||O(this.promise),U(e)?(this.length=e.length,this._remaining=e.length,this._result=new Array(this.length),0===this.length?S(this.promise,this._result):(this.length=this.length||0,this._enumerate(e),0===this._remaining&&S(this.promise,this._result))):j(this.promise,k())}return t.prototype._enumerate=function(t){for(var e=0;this._state===$&&e<t.length;e++)this._eachEntry(t[e],e)},t.prototype._eachEntry=function(t,e){var n=this._instanceConstructor,r=n.resolve;if(r===h){var o=_(t);if(o===l&&t._state!==$)this._settledAt(t._state,e,t._result);else if("function"!=typeof o)this._remaining--,this._result[e]=t;else if(n===it){var i=new n(p);w(i,t,o),this._willSettleAt(i,e)}else this._willSettleAt(new n(function(e){return e(t)}),e)}else this._willSettleAt(r(t),e)},t.prototype._settledAt=function(t,e,n){var r=this.promise;r._state===$&&(this._remaining--,t===et?j(r,n):this._result[e]=n),0===this._remaining&&S(r,this._result)},t.prototype._willSettleAt=function(t,e){var n=this;E(t,void 0,function(t){return n._settledAt(tt,e,t)},function(t){return n._settledAt(et,e,t)})},t}(),it=function(){function t(e){this[Z]=C(),this._result=this._state=void 0,this._subscribers=[],p!==e&&("function"!=typeof e&&D(),this instanceof t?x(this,e):K())}return t.prototype["catch"]=function(t){return this.then(null,t)},t.prototype["finally"]=function(t){var n=this,r=n.constructor;return e(t)?n.then(function(e){return r.resolve(t()).then(function(){return e})},function(e){return r.resolve(t()).then(function(){throw e})}):n.then(t,t)},t}();return it.prototype.then=l,it.all=F,it.race=Y,it.resolve=h,it.reject=q,it._setScheduler=n,it._setAsap=r,it._asap=G,it.polyfill=L,it.Promise=it,it.polyfill(),it});

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"_process":1}],15:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define("Siema",[],t):"object"==typeof exports?exports.Siema=t():e.Siema=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(i[r])return i[r].exports;var n=i[r]={i:r,l:!1,exports:{}};return e[r].call(n.exports,n,n.exports,t),n.l=!0,n.exports}var i={};return t.m=e,t.c=i,t.d=function(e,i,r){t.o(e,i)||Object.defineProperty(e,i,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var i=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(i,"a",i),i},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,i){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},s=function(){function e(e,t){for(var i=0;i<t.length;i++){var r=t[i];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,i,r){return i&&e(t.prototype,i),r&&e(t,r),t}}(),l=function(){function e(t){var i=this;if(r(this,e),this.config=e.mergeSettings(t),this.selector="string"==typeof this.config.selector?document.querySelector(this.config.selector):this.config.selector,null===this.selector)throw new Error("Something wrong with your selector 😭");this.resolveSlidesNumber(),this.selectorWidth=this.selector.offsetWidth,this.innerElements=[].slice.call(this.selector.children),this.currentSlide=this.config.loop?this.config.startIndex%this.innerElements.length:Math.max(0,Math.min(this.config.startIndex,this.innerElements.length-this.perPage)),this.transformProperty=e.webkitOrNot(),["resizeHandler","touchstartHandler","touchendHandler","touchmoveHandler","mousedownHandler","mouseupHandler","mouseleaveHandler","mousemoveHandler","clickHandler"].forEach(function(e){i[e]=i[e].bind(i)}),this.init()}return s(e,[{key:"attachEvents",value:function(){window.addEventListener("resize",this.resizeHandler),this.config.draggable&&(this.pointerDown=!1,this.drag={startX:0,endX:0,startY:0,letItGo:null,preventClick:!1},this.selector.addEventListener("touchstart",this.touchstartHandler),this.selector.addEventListener("touchend",this.touchendHandler),this.selector.addEventListener("touchmove",this.touchmoveHandler),this.selector.addEventListener("mousedown",this.mousedownHandler),this.selector.addEventListener("mouseup",this.mouseupHandler),this.selector.addEventListener("mouseleave",this.mouseleaveHandler),this.selector.addEventListener("mousemove",this.mousemoveHandler),this.selector.addEventListener("click",this.clickHandler))}},{key:"detachEvents",value:function(){window.removeEventListener("resize",this.resizeHandler),this.selector.removeEventListener("touchstart",this.touchstartHandler),this.selector.removeEventListener("touchend",this.touchendHandler),this.selector.removeEventListener("touchmove",this.touchmoveHandler),this.selector.removeEventListener("mousedown",this.mousedownHandler),this.selector.removeEventListener("mouseup",this.mouseupHandler),this.selector.removeEventListener("mouseleave",this.mouseleaveHandler),this.selector.removeEventListener("mousemove",this.mousemoveHandler),this.selector.removeEventListener("click",this.clickHandler)}},{key:"init",value:function(){this.attachEvents(),this.selector.style.overflow="hidden",this.selector.style.direction=this.config.rtl?"rtl":"ltr",this.buildSliderFrame(),this.config.onInit.call(this)}},{key:"buildSliderFrame",value:function(){var e=this.selectorWidth/this.perPage,t=this.config.loop?this.innerElements.length+2*this.perPage:this.innerElements.length;this.sliderFrame=document.createElement("div"),this.sliderFrame.style.width=e*t+"px",this.enableTransition(),this.config.draggable&&(this.selector.style.cursor="-webkit-grab");var i=document.createDocumentFragment();if(this.config.loop)for(var r=this.innerElements.length-this.perPage;r<this.innerElements.length;r++){var n=this.buildSliderFrameItem(this.innerElements[r].cloneNode(!0));i.appendChild(n)}for(var s=0;s<this.innerElements.length;s++){var l=this.buildSliderFrameItem(this.innerElements[s]);i.appendChild(l)}if(this.config.loop)for(var o=0;o<this.perPage;o++){var a=this.buildSliderFrameItem(this.innerElements[o].cloneNode(!0));i.appendChild(a)}this.sliderFrame.appendChild(i),this.selector.innerHTML="",this.selector.appendChild(this.sliderFrame),this.slideToCurrent()}},{key:"buildSliderFrameItem",value:function(e){var t=document.createElement("div");return t.style.cssFloat=this.config.rtl?"right":"left",t.style.float=this.config.rtl?"right":"left",t.style.width=(this.config.loop?100/(this.innerElements.length+2*this.perPage):100/this.innerElements.length)+"%",t.appendChild(e),t}},{key:"resolveSlidesNumber",value:function(){if("number"==typeof this.config.perPage)this.perPage=this.config.perPage;else if("object"===n(this.config.perPage)){this.perPage=1;for(var e in this.config.perPage)window.innerWidth>=e&&(this.perPage=this.config.perPage[e])}}},{key:"prev",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,t=arguments[1];if(!(this.innerElements.length<=this.perPage)){var i=this.currentSlide;if(this.config.loop){if(this.currentSlide-e<0){this.disableTransition();var r=this.currentSlide+this.innerElements.length,n=this.perPage,s=r+n,l=(this.config.rtl?1:-1)*s*(this.selectorWidth/this.perPage),o=this.config.draggable?this.drag.endX-this.drag.startX:0;this.sliderFrame.style[this.transformProperty]="translate3d("+(l+o)+"px, 0, 0)",this.currentSlide=r-e}else this.currentSlide=this.currentSlide-e}else this.currentSlide=Math.max(this.currentSlide-e,0);i!==this.currentSlide&&(this.slideToCurrent(this.config.loop),this.config.onChange.call(this),t&&t.call(this))}}},{key:"next",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,t=arguments[1];if(!(this.innerElements.length<=this.perPage)){var i=this.currentSlide;if(this.config.loop){if(this.currentSlide+e>this.innerElements.length-this.perPage){this.disableTransition();var r=this.currentSlide-this.innerElements.length,n=this.perPage,s=r+n,l=(this.config.rtl?1:-1)*s*(this.selectorWidth/this.perPage),o=this.config.draggable?this.drag.endX-this.drag.startX:0;this.sliderFrame.style[this.transformProperty]="translate3d("+(l+o)+"px, 0, 0)",this.currentSlide=r+e}else this.currentSlide=this.currentSlide+e}else this.currentSlide=Math.min(this.currentSlide+e,this.innerElements.length-this.perPage);i!==this.currentSlide&&(this.slideToCurrent(this.config.loop),this.config.onChange.call(this),t&&t.call(this))}}},{key:"disableTransition",value:function(){this.sliderFrame.style.webkitTransition="all 0ms "+this.config.easing,this.sliderFrame.style.transition="all 0ms "+this.config.easing}},{key:"enableTransition",value:function(){this.sliderFrame.style.webkitTransition="all "+this.config.duration+"ms "+this.config.easing,this.sliderFrame.style.transition="all "+this.config.duration+"ms "+this.config.easing}},{key:"goTo",value:function(e,t){if(!(this.innerElements.length<=this.perPage)){var i=this.currentSlide;this.currentSlide=this.config.loop?e%this.innerElements.length:Math.min(Math.max(e,0),this.innerElements.length-this.perPage),i!==this.currentSlide&&(this.slideToCurrent(),this.config.onChange.call(this),t&&t.call(this))}}},{key:"slideToCurrent",value:function(e){var t=this,i=this.config.loop?this.currentSlide+this.perPage:this.currentSlide,r=(this.config.rtl?1:-1)*i*(this.selectorWidth/this.perPage);e?requestAnimationFrame(function(){requestAnimationFrame(function(){t.enableTransition(),t.sliderFrame.style[t.transformProperty]="translate3d("+r+"px, 0, 0)"})}):this.sliderFrame.style[this.transformProperty]="translate3d("+r+"px, 0, 0)"}},{key:"updateAfterDrag",value:function(){var e=(this.config.rtl?-1:1)*(this.drag.endX-this.drag.startX),t=Math.abs(e),i=this.config.multipleDrag?Math.ceil(t/(this.selectorWidth/this.perPage)):1,r=e>0&&this.currentSlide-i<0,n=e<0&&this.currentSlide+i>this.innerElements.length-this.perPage;e>0&&t>this.config.threshold&&this.innerElements.length>this.perPage?this.prev(i):e<0&&t>this.config.threshold&&this.innerElements.length>this.perPage&&this.next(i),this.slideToCurrent(r||n)}},{key:"resizeHandler",value:function(){this.resolveSlidesNumber(),this.currentSlide+this.perPage>this.innerElements.length&&(this.currentSlide=this.innerElements.length<=this.perPage?0:this.innerElements.length-this.perPage),this.selectorWidth=this.selector.offsetWidth,this.buildSliderFrame()}},{key:"clearDrag",value:function(){this.drag={startX:0,endX:0,startY:0,letItGo:null,preventClick:this.drag.preventClick}}},{key:"touchstartHandler",value:function(e){-1!==["TEXTAREA","OPTION","INPUT","SELECT"].indexOf(e.target.nodeName)||(e.stopPropagation(),this.pointerDown=!0,this.drag.startX=e.touches[0].pageX,this.drag.startY=e.touches[0].pageY)}},{key:"touchendHandler",value:function(e){e.stopPropagation(),this.pointerDown=!1,this.enableTransition(),this.drag.endX&&this.updateAfterDrag(),this.clearDrag()}},{key:"touchmoveHandler",value:function(e){if(e.stopPropagation(),null===this.drag.letItGo&&(this.drag.letItGo=Math.abs(this.drag.startY-e.touches[0].pageY)<Math.abs(this.drag.startX-e.touches[0].pageX)),this.pointerDown&&this.drag.letItGo){e.preventDefault(),this.drag.endX=e.touches[0].pageX,this.sliderFrame.style.webkitTransition="all 0ms "+this.config.easing,this.sliderFrame.style.transition="all 0ms "+this.config.easing;var t=this.config.loop?this.currentSlide+this.perPage:this.currentSlide,i=t*(this.selectorWidth/this.perPage),r=this.drag.endX-this.drag.startX,n=this.config.rtl?i+r:i-r;this.sliderFrame.style[this.transformProperty]="translate3d("+(this.config.rtl?1:-1)*n+"px, 0, 0)"}}},{key:"mousedownHandler",value:function(e){-1!==["TEXTAREA","OPTION","INPUT","SELECT"].indexOf(e.target.nodeName)||(e.preventDefault(),e.stopPropagation(),this.pointerDown=!0,this.drag.startX=e.pageX)}},{key:"mouseupHandler",value:function(e){e.stopPropagation(),this.pointerDown=!1,this.selector.style.cursor="-webkit-grab",this.enableTransition(),this.drag.endX&&this.updateAfterDrag(),this.clearDrag()}},{key:"mousemoveHandler",value:function(e){if(e.preventDefault(),this.pointerDown){"A"===e.target.nodeName&&(this.drag.preventClick=!0),this.drag.endX=e.pageX,this.selector.style.cursor="-webkit-grabbing",this.sliderFrame.style.webkitTransition="all 0ms "+this.config.easing,this.sliderFrame.style.transition="all 0ms "+this.config.easing;var t=this.config.loop?this.currentSlide+this.perPage:this.currentSlide,i=t*(this.selectorWidth/this.perPage),r=this.drag.endX-this.drag.startX,n=this.config.rtl?i+r:i-r;this.sliderFrame.style[this.transformProperty]="translate3d("+(this.config.rtl?1:-1)*n+"px, 0, 0)"}}},{key:"mouseleaveHandler",value:function(e){this.pointerDown&&(this.pointerDown=!1,this.selector.style.cursor="-webkit-grab",this.drag.endX=e.pageX,this.drag.preventClick=!1,this.enableTransition(),this.updateAfterDrag(),this.clearDrag())}},{key:"clickHandler",value:function(e){this.drag.preventClick&&e.preventDefault(),this.drag.preventClick=!1}},{key:"remove",value:function(e,t){if(e<0||e>=this.innerElements.length)throw new Error("Item to remove doesn't exist 😭");var i=e<this.currentSlide,r=this.currentSlide+this.perPage-1===e;(i||r)&&this.currentSlide--,this.innerElements.splice(e,1),this.buildSliderFrame(),t&&t.call(this)}},{key:"insert",value:function(e,t,i){if(t<0||t>this.innerElements.length+1)throw new Error("Unable to inset it at this index 😭");if(-1!==this.innerElements.indexOf(e))throw new Error("The same item in a carousel? Really? Nope 😭");var r=t<=this.currentSlide>0&&this.innerElements.length;this.currentSlide=r?this.currentSlide+1:this.currentSlide,this.innerElements.splice(t,0,e),this.buildSliderFrame(),i&&i.call(this)}},{key:"prepend",value:function(e,t){this.insert(e,0),t&&t.call(this)}},{key:"append",value:function(e,t){this.insert(e,this.innerElements.length+1),t&&t.call(this)}},{key:"destroy",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=arguments[1];if(this.detachEvents(),this.selector.style.cursor="auto",e){for(var i=document.createDocumentFragment(),r=0;r<this.innerElements.length;r++)i.appendChild(this.innerElements[r]);this.selector.innerHTML="",this.selector.appendChild(i),this.selector.removeAttribute("style")}t&&t.call(this)}}],[{key:"mergeSettings",value:function(e){var t={selector:".siema",duration:200,easing:"ease-out",perPage:1,startIndex:0,draggable:!0,multipleDrag:!0,threshold:20,loop:!1,rtl:!1,onInit:function(){},onChange:function(){}},i=e;for(var r in i)t[r]=i[r];return t}},{key:"webkitOrNot",value:function(){return"string"==typeof document.documentElement.style.transform?"transform":"WebkitTransform"}}]),e}();t.default=l,e.exports=t.default}])});
},{}]},{},[5])

